var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"header-logo",on:{"click":_vm.logoPage}}),(_vm.titleList.length)?_c('div',{staticClass:"header-right"},[_c('TextSwiper',{attrs:{"titleList":_vm.titleList}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }